<template>
  <div class="app-container">
    <router-view v-slot="{ Component, route }">
      <keep-alive>
        <component v-if="route.meta.keepAlive" :is="Component" :key="route.name"></component>
      </keep-alive>
        <component v-if="!route.meta.keepAlive" :is="Component" :key="route.name"></component>
    </router-view>
    <div @click="toBack" v-show="showBack" class="back-button">
      <img src="https://wxapp.gz-cmc.com/wxapp/html/listen-h5/images/back.png" />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const showBack = computed(() => route.name?.toLocaleLowerCase().indexOf('detail') >= 0);
const toBack = () => {
  if (router.options.history.state.back) {
    router.back();
  } else {
    router.replace({ name: 'index' });
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .back-button {
    width: 45px;
    height: 45px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    opacity: 0.7;
    img {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
